import './App.css';

function App() {
  return (
    <div style={{maxWidth: 800}}>
        <p>
         Nós respeitamos a privacidade de nossos usuários (“usuário” ou “você”).
         Esta Política de Privacidade explica como coletamos, usamos, divulgamos e protegemos suas informações quando você visita nossos aplicativos móveis. Por favor, leia esta política de privacidade com cuidado. SE VOCÊ NÃO CONCORDA COM OS TERMOS DESTA POLÍTICA DE PRIVACIDADE, POR FAVOR, NÃO ACESSE OS APLICATIVOS.
        Reservamo-nos o direito de fazer alterações a esta Política de Privacidade a qualquer momento e por qualquer motivo.
        </p>
        <h3>COLETA DE INFORMAÇÕES</h3>
        <p>
          Podemos coletar informações sobre você de várias maneiras. As informações que podemos coletar por meio dos Aplicativos dependem do conteúdo e dos materiais que você usa e incluem:
        </p>
        <h4>Dados pessoais</h4>
        <p>
          Informações demográficas e outras informações de identificação pessoal (como seu nome e endereço de e-mail) que você nos fornece voluntariamente ao optar por participar de várias atividades relacionadas aos Aplicativos, como bate-papo, postagem de mensagens em seções de comentários ou em nossos fóruns, curtindo postagens, enviando feedback e respondendo a pesquisas. Se você optar por compartilhar dados sobre você por meio de seu perfil, bate-papo online ou outras áreas interativas dos Aplicativos, saiba que todos os dados divulgados nessas áreas são públicos e seus dados estarão acessíveis a qualquer pessoa que acesse os Aplicativos.
        </p>
        <h4>Acesso a dispositivos móveis</h4>
        <p>
          Podemos solicitar acesso ou permissão a determinados recursos do seu dispositivo móvel, incluindo câmera, contatos, microfone, lembretes, sensores, contas de mídia social, armazenamento e outros recursos do seu dispositivo móvel. Se você deseja alterar nosso acesso ou permissões, você pode fazê-lo nas configurações do seu dispositivo.
        </p>
        <h3>USO DE SUAS INFORMAÇÕES</h3>
        <p>
        Ter informações precisas sobre você nos permite fornecer uma experiência tranquila, eficiente e personalizada. Especificamente, podemos usar as informações coletadas sobre você por meio dos Aplicativos para:
        </p>
        <ul>
          <li>Administrar sorteios, promoções e concursos.</li>
          <li>Compilar dados estatísticos anônimos e análises para uso interno ou com terceiros.</li>
          <li>Entregar publicidade direcionada, cupons, boletins informativos e outras informações sobre promoções e os Aplicativos para você.</li>
          <li>Notificá-lo sobre atualizações nos Aplicativos.</li>
          <li>Atender e gerenciar compras, pedidos, pagamentos e outras transações relacionadas aos Aplicativos.</li>
        </ul>
    </div>
  );
}

export default App;
